"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
exports.reportSchema = Yup.object()
  .shape({
    reportConditions: Yup.object()
      .shape({
        onlyOnData: Yup.boolean().required("required")
      })
      .required(),
    transport: Yup.object()
      .shape({
        type: Yup.mixed().required(),
        options: Yup.object()
          .shape({
            recipient: Yup.string().when("type", {
              is: "email",
              then: Yup.string()
                .email()
                .required(),
              otherwise: Yup.string()
            }),
            slackConfig: Yup.string().when("type", {
              is: "slack",
              then: Yup.string().required(),
              otherwise: Yup.string()
            })
          })
          .required()
      })
      .required()
  })
  .required();
class ReportNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    let selectedResource = node.getSelectedResource();
    return helper_1.isValid(
      [
        { schema: exports.reportSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() },
        { schema: IValidation_1.selectedResourceSchema, data: selectedResource }
      ],
      node.getNodeId()
    );
  }
}
exports.ReportNodeValidation = ReportNodeValidation;
//# sourceMappingURL=ReportNodeValidation.js.map
